import { getSpamProtectionMetadata } from '../../selectors/widgetDataSelectors/getSpamProtectionMetadata';
import { useSelector } from 'react-redux';
import { getWidgetLocation } from '../../selectors/widgetDataSelectors/getWidgetLocation';
import { AIPromptRecommendations } from 'conversations-visitor-experience-components/customer-agent/AIPromptRecommendations';
import ConsentPromptsOutsideChat from 'conversations-visitor-experience-components/visitor-widget/components/ConsentPromptsOutsideChat';
import { useConsentPromptData } from '../../hooks/useConsentPromptData';
import { getIsPortal53 } from '../../widget-data/operators/getIsPortal53';
import { useCustomerAgentHover } from 'conversations-visitor-experience-components/contexts/CustomerAgentHoverContext';
import { useAIPromptRecommendations } from '../../hooks/useAIPromptRecommendations';
import ConsentPromptTransitionWrapper from '../../components/ConsentPromptTransitionWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AIPromptsContainerOutsideChat = ({
  clickedFrom
}) => {
  const widgetLocation = useSelector(getWidgetLocation);
  const {
    isHoverActive
  } = useCustomerAgentHover();
  const isPortal53 = getIsPortal53();
  const spamProtectionMetadata = useSelector(getSpamProtectionMetadata);
  const spamProtectionEnabled = Boolean(spamProtectionMetadata === null || spamProtectionMetadata === void 0 ? void 0 : spamProtectionMetadata.token);
  const {
    consentPromptEnabled,
    consentToProcessMessage,
    showGdprConsentToProcessButton,
    showingGdprProcess,
    renderCookieConsentPrompt,
    consentToProcess,
    consentToCookies,
    closeConsentToProcess
  } = useConsentPromptData();
  const {
    recommendedQuestionsForAgent,
    coloring,
    isAIChatBot,
    handlePromptClick,
    handlePromptTrack
  } = useAIPromptRecommendations({
    clickedFrom,
    shouldOpenWidget: true,
    shouldLoadStagedThread: true,
    errorMessage: 'Failed to publish message from AI prompts outside chat'
  });
  const shouldShowPromptRecommendations = !renderCookieConsentPrompt && !showGdprConsentToProcessButton && (isHoverActive || showingGdprProcess);
  return /*#__PURE__*/_jsxs(ConsentPromptTransitionWrapper, {
    consentPromptEnabled: consentPromptEnabled || spamProtectionEnabled,
    isVisible: isAIChatBot && isHoverActive,
    children: [/*#__PURE__*/_jsx(AIPromptRecommendations, {
      recommendedQuestionsForAgent: recommendedQuestionsForAgent,
      widgetLocation: widgetLocation,
      coloring: coloring,
      insideChat: false,
      onPromptClick: handlePromptClick,
      onPromptTrack: handlePromptTrack,
      shouldShow: shouldShowPromptRecommendations
    }), /*#__PURE__*/_jsx(ConsentPromptsOutsideChat, {
      renderCookieConsentPrompt: renderCookieConsentPrompt,
      showingGdprProcess: showingGdprProcess,
      consentToProcessMessage: consentToProcessMessage,
      showGdprConsentToProcessButton: showGdprConsentToProcessButton,
      consentToProcess: consentToProcess,
      closeConsentToProcess: closeConsentToProcess,
      consentToCookies: consentToCookies,
      isPortal53: isPortal53,
      usageType: "prompt-recommendations",
      spamProtectionEnabled: spamProtectionEnabled
    })]
  });
};
AIPromptsContainerOutsideChat.displayName = 'AIPromptsContainerOutsideChat';
export default AIPromptsContainerOutsideChat;